import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUser } from "../../context/UserContext.jsx";
import { Images } from "../Common/Images.jsx";
import { setAccessToken, setRefreshToken, setGuId, setLoginId, setFirstname, setLastname, setEmailID } from "../../utils/SecurityService.js";
import { Profile_api } from "../Login/LoginAPI.js";

function AutoLogin() {
  const history = useHistory();
  const { setUser } = useUser();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const atoken = params.get("atoken");
    const rtoken = params.get("rtoken");
    const uid = params.get("uid");
    const isQueryAvailable = [atoken, rtoken, uid].every((param) => param && param.trim().length > 0);

    if (!isQueryAvailable) {
      window.setTimeout(() => history.replace("/login"), 1000);
      return;
    }

    const completeAutoLogin = async () => {
      try {
        setIsLoading(true);
        setAccessToken(atoken);
        setRefreshToken(rtoken);
        setGuId(uid);

        const response = await Profile_api({ GuId: uid });

        if (response?.Data?.ResponseCode !== 200) {
          const errorText = response?.Data?.ErrorMessage;
          throw new Error(errorText);
        }

        const records = response?.Data?.Records || {};

        if (records?.FirstName) setFirstname(records.FirstName);
        if (records?.LastName) setLastname(records.LastName);
        if (records?.PrimaryEmail) setEmailID(records.PrimaryEmail);

        const loginId = records?.Id || records?.id;
        if (loginId) setLoginId(loginId);

        if (records?.Notifications !== undefined && records?.Notifications !== null) {
          sessionStorage.setItem("Notifications", records.Notifications);
        }

        setUser({
          firstName: records?.FirstName || "",
          lastName: records?.LastName || "",
        });

        window.history.replaceState({}, document.title, window.location.pathname);
        history.replace("/calendar");
      } catch (error) {
        console.error("AutoLogin failed:", error);
        setIsLoading(false);
        window.setTimeout(() => history.replace("/login"), 2000);
      }
    };

    completeAutoLogin();
  }, [history, setUser]);

  return (
    <div className="autologin-page" style={{ padding: "24px", textAlign: "center" }}>
      {isLoading && (
        <div id="preloader">
          <img src={Images.LoaderFull} alt="Loading" />
        </div>
      )}
     <img src={Images.LogoBig} alt="Ronspot Logo" />
      
    </div>
  );
}

export default AutoLogin;
